<template>
  <div class="flex-1 overflow-auto p-4">
    <!-- List Agents -->
    <div>
      <woot-loading-state
        v-if="uiFlags.isFetching"
        :message="$t('AGENT_MGMT.LOADING')"
      />
      <div v-else>
        <p v-if="!agentList.length">
          {{ $t('AGENT_MGMT.LIST.404') }}
        </p>
        <div v-else v-resize="onResize" class="flex flex-col gap-1">
          <agent-item
            v-for="(agent, index) in agentList"
            :key="agent.email"
            :agent="agent"
            :open-edit-popup="openEditPopup"
            :open-delete-popup="openDeletePopup"
            :open-disconnect-popup="openDisconnectPopup"
            :element-width="width"
          />
        </div>
      </div>
    </div>
    <!-- Edit Agent -->
    <woot-modal
      :show.sync="showEditPopup"
      :on-close="hideEditPopup"
      class="edit-agent-modal"
    >
      <edit-agent
        v-if="showEditPopup"
        :id="currentAgent.id"
        :name="currentAgent.name"
        :type="currentAgent.role"
        :email="currentAgent.email"
        :see-all-conversations="currentAgent.see_all_conversations"
        :availability="currentAgent.availability_status"
        :two-factor-type="currentAgent.two_factor_type"
        :phone1="currentAgent.phone1"
        :email1="currentAgent.email1"
        :on-close="hideEditPopup"
        :agent-custom-attributes="currentAgent.custom_attributes"
        :capacity-cap="currentAgent.capacity_cap"
      />
    </woot-modal>
    <!-- Delete Agent -->
    <woot-modal
      :show.sync="showDeletePopup"
      :on-close="closeDeletePopup"
      class="delete-modal"
    >
      <delete-agent
        :agent="currentAgent"
        :close-delete-popup="closeDeletePopup"
      />
    </woot-modal>
    <woot-modal
      :show.sync="showDisconnectPopup"
      :on-close="closeDisconnectPopup"
      class="delete-modal"
    >
      <disconnect-agent
        :agent="currentAgent"
        :close-disconnect-popup="closeDisconnectPopup"
      />
    </woot-modal>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import globalConfigMixin from 'shared/mixins/globalConfigMixin';
import EditAgent from './EditAgent.vue';
import AgentItem from './AgentItem.vue';
import DeleteAgent from './DeleteAgent.vue';
import DisconnectAgent from './DisconnectAgent.vue';
import hasPermissionMixin from 'dashboard/mixins/hasPermission';

export default {
  components: {
    EditAgent,
    AgentItem,
    DeleteAgent,
    DisconnectAgent,
  },
  mixins: [globalConfigMixin, hasPermissionMixin],
  data() {
    return {
      loading: {},
      showDeletePopup: false,
      showDisconnectPopup: false,
      showEditPopup: false,
      agentAPI: {
        message: '',
      },
      currentAgent: {},
      height: null,
      width: null,
    };
  },
  computed: {
    ...mapGetters({
      agentList: 'agents/getAgents',
      uiFlags: 'agents/getUIFlags',
      currentUserId: 'getCurrentUserID',
      globalConfig: 'globalConfig/get',
    }),
    showDisconnect() {
      return this.hasEditPermissionNew('Disconnect Agents');
    },
  },
  mounted() {
    this.$store.dispatch('agents/get');
  },
  methods: {
    // Edit Function
    openEditPopup(agent) {
      this.showEditPopup = true;
      this.currentAgent = agent;
    },
    hideEditPopup() {
      this.showEditPopup = false;
    },
    // Delete Function
    openDeletePopup(agent) {
      this.showDeletePopup = true;
      this.currentAgent = agent;
    },
    closeDeletePopup() {
      this.showDeletePopup = false;
    },
    openDisconnectPopup(agent) {
      this.showDisconnectPopup = true;
      this.currentAgent = agent;
    },
    closeDisconnectPopup() {
      this.showDisconnectPopup = false;
    },
    onResize(entry) {
      const { width, height } = entry.contentRect;
      this.width = width;
      this.height = height;
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .delete-modal {
    .modal-container {
      @apply rounded-[12px];
    }
  }
}
</style>
